export const SIZES = {
  bigTitle: '6rem',
  xxxxxxl: '3rem',
  xxxxxl: '2rem',
  xxxxl: '1.5rem',
  xxxl: '1.375rem',
  xxl: '1.25rem',
  xl: '1.125rem',
  default: '1rem', // 16px by the default
  m: '0.875rem',
  s: '0.75rem',
  xs: '0.625rem',
  xxs: '0.5rem',
}

export const FAMILIES = {
  poppins: "'Poppins', sans-serif",
  kanit: "'Kanit', sans-serif",
  notoSans: "'Noto Sans', sans-serif",
}

export const WEIGHTS = {
  light: '400',
  normal: '500',
  medium: '600',
  semi_bold: '600',
  bold: '700',
  black: '800',
}
